import { render } from "./YatirimlarWhiteSvg.vue?vue&type=template&id=b345e4cc&scoped=true"
import script from "./YatirimlarWhiteSvg.vue?vue&type=script&lang=js"
export * from "./YatirimlarWhiteSvg.vue?vue&type=script&lang=js"

import "./YatirimlarWhiteSvg.vue?vue&type=style&index=0&id=b345e4cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b345e4cc"]])

export default __exports__